import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { MroSmartcarApiServiceMock } from '@mocks/mro-smartcar-api-mock.service';
import { MroSmartcarApiService } from '../mro-smartcar-api.service';
import { MroSmartcarRepository } from '../mro-smartcar.repository';

export const HTTP_MRO_SMARTCAR_SERVICE = new InjectionToken<MroSmartcarRepository>('MroSmartcarRepository');

export const MRO_SMARTCAR_API_PROVIDER: Provider = {
    provide: HTTP_MRO_SMARTCAR_SERVICE,
    useClass: environment.useMocks && environment.useMocks.mroSmartcar ? MroSmartcarApiServiceMock : MroSmartcarApiService,
};
